import Vue from "vue";
import Router from "vue-router";
import Index from "../pages/thirdAnniversary/index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "/thirdAnniversary",
    routes: [{
            path: "/enter*",
            name: `enter`,
            component: Index
        }
        // {
        //   path: '/pc*',
        //   name: 'card-pc',
        //   component: Pc
        // }
    ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/thirdAnniversary.js